////////////////////////////////////////////////////////////////////////////////
// Copyright 2019 Federated Wireless.
//
// GOVERNMENT PURPOSE RIGHTS
//
// Contractor Name:    Federated Wireless
// Contractor Address: 3865 Wilson Blvd, Arlington, VA 22203
//
// The Government's rights to use, modify, reproduce, release, perform, display,
// or disclose this software are restricted by paragraph (b)(2) of the Rights in
// Noncommercial Computer Software and Noncommercial Computer Software
// Documentation clause contained in the 7013 Clause. Any reproduction of the
// software or portions thereof marked with this legend must also reproduce the
// markings.
// This source code delivery is exclusively for Government Purposes pertaining
// to this program; no commercial use. The Computer Software Configuration
// Items were delivered for only the purposes spelled out by the contract
// delivered under.
//
// Export Warning - The technical data in this document (or file) is
// controlled for export under the International Traffic in Arms Regulations
// (ITAR), 22CFR 120-130.  Violations of these export laws may be subject to
// fines and penalties under the Arms Export Control Act (22 U.S.C. 2778).
//
////////////////////////////////////////////////////////////////////////////////
//
// Security Classification: UNCLASSIFIED
//
////////////////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import { reduxForm, formValueSelector } from 'redux-form';
import A1A2 from './a1a2'
import A3A4A5A6 from './a3a4a5a6'
import validate from './validate'
import { connect } from 'react-redux'

class TddFormPage extends Component {

  renderError = ({ meta: { touched, error } }) =>
    touched && 
    error ? <span>{error}</span> : false



  render(){
    var { handleSubmit, previousPage, entity, existingcustomer, disable3, disable4, disable5 } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <h2>Organisation Profile</h2>
        {this.props.page ===1 && <React.Fragment>
          <h3>Applicant Details <em>for Ofcom OfW588 form, Section A1-2</em></h3>
          <A1A2 entity={entity} existingcustomer={existingcustomer}/>
          {existingcustomer ==="false" && <React.Fragment>
              <h3>Licencee name and address <em>for Ofcom OfW588 form, Section A3</em></h3>
              <A3A4A5A6 fieldprexix="" disableCopyOption={true} showTradingName={true}></A3A4A5A6>
          </React.Fragment>}
        </React.Fragment>}
        {this.props.page ===2 && <React.Fragment>
          <h3>Licence contact details <em>for Ofcom OfW588 form, Section A4</em></h3>
          <A3A4A5A6 disableFields={disable3 && existingcustomer ==="false"} disableCopyOption={existingcustomer ==="true"} fieldprexix="3"></A3A4A5A6>
        </React.Fragment>}
        {this.props.page ===3 && <React.Fragment>
          <h3>Contact details for payments or account queries <em>for Ofcom OfW588 form, Section A5</em></h3>
          <A3A4A5A6 disableFields={disable4} fieldprexix="4"></A3A4A5A6>
        </React.Fragment>}
        {this.props.page ===4 && <React.Fragment>
          <h3>Contact name and address for site and technical enquiries <em>for Ofcom OfW588 form, Section A6</em></h3>
          <A3A4A5A6 disableFields={disable5} fieldprexix="5"></A3A4A5A6>
        </React.Fragment>}

        <div className="button-row">
        {this.props.page >1 && <button type="button" className="btn btn-light btn-lg" disabled={false} onClick={previousPage}>
              Previous Page
          </button>}
          <button type="submit" className="btn btn-primary" disabled={/*pristine || submitting*/false} onClick={handleSubmit}>Continue</button>
        </div>
      </form>
    );
  };

}


TddFormPage = reduxForm({
  form: 'userprofile', // a unique identifier for this form
  destroyOnUnmount: true, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate
})(TddFormPage)

const selector = formValueSelector('userprofile')

TddFormPage = connect(
  state => {
    let entity = selector(state, 'entity')
    let existingcustomer = selector(state, 'existingcustomer')


    let copyLastPage =  (copySourcePage, currentPage) =>{
        if (selector(state, 'copylast'+currentPage)){
            for (let field of ['licenceename','licenceeaddress','licenceepostcode','licenceecountry','telephone','mobile','fax','email']){
                state.form.userprofile.values[field+currentPage] = state.form.userprofile.values[field+copySourcePage]
            }
            return true
        }
        return false
    }

    let disable3 = false

    if (existingcustomer==="false" && copyLastPage("","3")){
        disable3 = true
    }

    let disable4 = copyLastPage("3","4")
    let disable5 = copyLastPage("3","5")
    return {
        entity,
        existingcustomer,
        disable3,
        disable4,
        disable5
    }
  }
)(TddFormPage)

export default TddFormPage



